export default __webpack_public_path__ + "static/media/AIModelColor.279fb027.svg";